import { RefObject, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useResizeObserver } from '@/hooks/useResizeObserver';

import { summarize } from '@/utils/stringUtils';

export const useEllipsis = <PItem>(
  ref: RefObject<HTMLElement>,
  items: PItem[],
  toDisplay: (item: PItem) => string,
) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');

  const updateSummary = (entry?: ResizeObserverEntry) => {
    if (!ref.current) {
      return;
    }

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d') as CanvasRenderingContext2D;
    const width = entry?.contentRect.width ?? ref.current.clientWidth;
    const explicit = items.map(toDisplay);
    let result = '';

    context.font = window.getComputedStyle(ref.current).font;

    while (explicit.length > 0) {
      result = summarize(explicit, items, t, 'common.plusMore');

      if (context.measureText(result).width <= width) {
        break;
      }

      explicit.pop();
    }

    setValue(result);
  };

  useEffect(updateSummary, [items, ref, t, toDisplay]);
  useResizeObserver(ref, updateSummary);

  return value;
};
